import { Button } from "reactstrap";
import { P } from "../../../../AbstractElements";
import IconComponent from "../../../../CommonElements/IconComponent";
import { convertTo12HourFormat } from "../../../../utils/timeUtils";

export interface AttendanceActionButtonProps {
  data: any;
  clockInTime: string | number | null;
  onClick: () => void;
}

const AttendanceActionButton = ({
  data,
  clockInTime,
  onClick,
}: AttendanceActionButtonProps) => {
  const hasClockedIn = data?.in_time !== null;
  const hasClockedOut = data?.out_time !== null;

  const label = hasClockedIn
    ? hasClockedOut
      ? "Total Duration:"
      : "Clock Out"
    : "Clock In";

  const timeDisplay = hasClockedIn
    ? hasClockedOut
      ? data?.working_hours
      : clockInTime
    : "";

  return (
    <Button
      className={`w-100 d-flex align-items-center justify-content-center opacity-100 ${
        hasClockedOut || (!hasClockedIn && !hasClockedOut) ? "p-2" : "p-0"
      }`}
      color={
        (!hasClockedIn && !hasClockedOut && "warning") ||
        (hasClockedIn && hasClockedOut && "success") ||
        "primary"
      }
      onClick={onClick}
      disabled={hasClockedIn && hasClockedOut}
    >
      <div
        className={`${
          !hasClockedIn && !hasClockedOut
            ? "w-100 d-flex justify-content-center m-0"
            : "w-50"
        }`}
      >
        <P className="m-0"> {label}</P>
      </div>
      <div
        className={`${!hasClockedIn && !hasClockedOut ? "" : "w-50"} ${
          !hasClockedOut ? "bg-danger" : "bg-success"
        }`}
        style={{
          borderTopRightRadius: "6px",
          borderBottomRightRadius: "6px",
          margin: "1px 1px 1px 0",
        }}
      >
        <P className="m-0">{timeDisplay}</P>
        {hasClockedIn && !hasClockedOut && (
          <P className="m-0">
            <IconComponent
              className="fa fa-long-arrow-down text-white"
              style={{ transform: "rotate(35deg)", marginTop: "5px" }}
            />
            <span className="ms-1">
              {convertTo12HourFormat(data?.in_time ?? "")}
            </span>
          </P>
        )}
      </div>
    </Button>
  );
};

export default AttendanceActionButton;
